<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M18 18v1H6v-1H4v4h2v-1h12v1h2v-4h-2ZM9 17h1v-2H9v-1h1v-2H9v-1h1V9H9V8h1V6h-.82c.41-1.16 1.51-2 2.82-2 1.31 0 2.4.84 2.82 2H14v2h1v1h-1v2h1v1h-1v2h1v1h-1v2h1v1h2V7c0-2.76-2.24-5-5-5S7 4.24 7 7v11h2v-1Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
